module.exports = __webpack_public_path__ + "static/media/hilda-win.86e22b45.png";